import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { langFromPath } from '../i18n/paths';

/**
 * Keeps i18n language in sync with the current URL prefix (/en -> EN, else IT).
 * Also keeps document.documentElement.lang updated for a11y and SEO.
 */
const LanguageRouter = () => {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const urlLang = langFromPath(location.pathname);
    const currentLang = (i18n.language || 'it').split('-')[0];
    if (urlLang !== currentLang) {
      i18n.changeLanguage(urlLang);
    }
    try { document.documentElement.lang = urlLang; } catch (e) { /* no-op */ }
  }, [location.pathname, i18n]);

  return null;
};

export default LanguageRouter;
